// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1WtCc","title":"styles_title__2yrAE"};